export default function EntryDownload() {
  return (
    <section id="download" className="scroll-mt-4">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="relative overflow-hidden border border-[#1a160e] bg-[#1a160e] px-6 py-12 md:px-12 md:py-16">
          {/* 边线点缀 */}
          <span
            className="absolute left-5 top-0 h-full w-px bg-white/10 md:left-8"
            aria-hidden="true"
          ></span>
          <div className="relative grid gap-10 lg:grid-cols-[1.6fr_1fr] lg:items-center">
            <div>
              <h4 className="flex items-center gap-2 text-[11px] tracking-[0.35em] text-[#f0b18a]">
                <i className="ri-download-2-line" aria-hidden="true"></i>
                档案入口 · 离线卷
              </h4>
              <h3 className="font-display mt-3 text-2xl font-black text-[#faf5eb] md:text-4xl">
                呱呱黑料离线卷
                <br />
                装进口袋慢慢翻
              </h3>
              <p className="mt-4 max-w-xl text-sm leading-7 text-[#c7bda5]">
                把整理好的历史旧账、早年言论与陈年往事打包成离线卷：不联网也能按时间线翻，
                新补录的考古发现自动跟进，适合夜深人静一段一段吃透。
              </p>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <a
                  href="#download"
                  className="inline-flex items-center justify-center gap-2 bg-[#b1401f] px-6 py-3.5 text-sm font-bold text-[#faf5eb] whitespace-nowrap transition hover:bg-[#852f12]"
                >
                  <i className="ri-smartphone-line text-lg" aria-hidden="true"></i>
                  下载呱呱黑料 App
                </a>
                <button
                  type="button"
                  className="inline-flex cursor-pointer items-center justify-center gap-2 border border-white/25 px-6 py-3.5 text-sm font-medium text-[#f3ead8] whitespace-nowrap transition hover:border-[#f0b18a] hover:text-[#f0b18a]"
                >
                  <i className="ri-file-zip-line text-lg" aria-hidden="true"></i>
                  打包本卷 PDF
                </button>
              </div>
              <p className="mt-3 text-[11px] tracking-widest text-[#6f6552]">
                仅展示入口，暂不接真实下载与登录。
              </p>
            </div>

            <aside className="border border-white/10 bg-white/5 p-6">
              <p className="flex items-center gap-2 text-xs tracking-widest text-[#f0b18a]">
                <i className="ri-checkbox-circle-line" aria-hidden="true"></i>
                离线卷里有什么
              </p>
              <ul className="mt-4 space-y-3 text-sm text-[#c7bda5]">
                {[
                  "全量早年言论语录卷（12 卷）",
                  "考古时间线：可离线按年份翻查",
                  "旧账卷宗六大门类持续补档",
                  "黑历史后续的完整对账笔记",
                ].map((t) => (
                  <li key={t} className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line mt-0.5 text-[#b1401f]" aria-hidden="true"></i>
                    <span>{t}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#download"
                className="mt-6 flex items-center justify-center gap-2 border border-white/20 py-3 text-xs tracking-widest text-[#f3ead8] transition hover:border-[#f0b18a] hover:text-[#f0b18a]"
              >
                <i className="ri-archive-line" aria-hidden="true"></i>
                进入归档检索台
              </a>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}